/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import "../../App.css";
import { Dropdown, Menu, Modal, Select, Space, Spin, Table, Tag, message } from "antd";
import { useEffect, useState, useMemo } from "react";
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import AddressFormadmin from "../forms/AddressFormadmin";
import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getQuotes } from "../../lib/quotes";
import { deleteDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import EditQuotesForm from "../forms/editQuoteForm";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
// import useNextOrderNumber from "./updateOrderNo";
import { generatePDF } from "../shared/pdf/generatePDF";
import Search from "../../icons/Search";
import AskForModel from "../shared/askForQuestion";
import { generateTrackingNumber } from "../../lib/helper/trackingNumber";
import { FormatDate } from "../../lib/dateFormat";
import Download from "../../icons/Downloadicon";
import axios from "axios";
import { API_BASE_URL, api } from "../../config/api";
import { DownOutlined } from "@ant-design/icons";
import DashboardLayout from "../layout";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import { useMyContext } from "../../context/MyContext";
import { getAdmins } from "../../lib/user";
import Loader from "../shared/loader/loader";
import ExportCSVPopup from "../ExportCSVPopup"; // Import the popup component

function Quoteadmin() {
  const obj = {
    ative: true,
    content: "Quote List",
  };
  // set create quote tab for admin
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const shipmentId = searchParams.get("quote");
  const { user, notifications } = useMyContext();
  const [createquote, setcreatequote] = useState(false);
  // show edit,del on click
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectId, setSelectId] = useState(shipmentId ? shipmentId : "");
  const [isModalOpen, setIsModalOpen] = useState(shipmentId ? true : false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  // show delete modal state
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [isAmountOpen, setIsAmountOpen] = useState(false);
  const [selectIdForAmount, setSelectIdForAmount] = useState(false);
  const [amount, setAmount] = useState("");
  const [formData, setFormData] = useState([]);
  const [currency, setCurrency] = useState("USD");
  const [disabledSendQuotes, setDisabledSendQuotes] = useState({});
  const queryClient = useQueryClient();
  const [quotesData, setQuotesData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [isDataProcessed, setIsDataProcessed] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleCurrencyChange = (selectedCurrency) => {
    setCurrency(selectedCurrency);
  };
  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
  };
  // const convertCurrency = () => {
  //   alert(`Amount in ${currency}: ${amount}`);
  // };

  // for edit and delete functionality
  const handleMenuClick = ({ key }) => {
    if (key === "edit") {
    } else if (key === "delete") {
      setShowDeleteConfirmationModal(true);
    }
    setMenuVisible(!menuVisible);
  };
  // close action buttons if click anywhere outside
  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false); // Close the menu if the click is outside the dropdown
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);

  const showModal = (id, quoteNumber) => {
    setSelectId(id);
    setIsModalOpen(true);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('quote', id);
    if (quoteNumber) {
      searchParams.set('quoteNumber', quoteNumber);
    } else {
      searchParams.delete('quoteNumber');
    }
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectId('');
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('quote');
    searchParams.delete('quoteNumber');
    navigate(`${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`, { replace: true });
  };

  const amountModal = (id) => {
    setSelectIdForAmount(id);
    // console.log(selectIdForAmount);
    setIsAmountOpen(true);
  };

  const handleAmountOk = () => {
    setIsModalOpen(false);
  };

  const handleAmountCancel = () => {
    setIsAmountOpen(false);
  };

  // quotes
  const { data, isLoading, isError, error, refetch } = useQuery(
    ["quotes", "adminQuery"],
    async () => {
      try {
        const res = await getQuotes();
        setQuotesData(res);
        setIsDataProcessed(true);
        setFetchError(null); // Clear any previous error
        return res;
      } catch (err) {
        console.error("Error in getQuotes:", err); // Log the error
        setIsDataProcessed(true); // Still set to true to allow rendering
        setFetchError(err.message); // Store the error
        throw err; // Re-throw to let React Query handle isError
      }
    },
    {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: true,
      refetchOnMount: true, // Force refetch on mount to avoid stale data
    }
  );

  // Whenever data changes, update quotesData state
  // useEffect(() => {
  //   if (data) {
  //     setQuotesData(data); // Store the data in the quotesData state
  //   }
  // }, [data]);

  // console.log("the setquetos data..",quotesData);

  const sortedData = useMemo(() => {
    if (!data) return [];

    return [...data].sort((a, b) => {
      const dateA = a.quoteCreatedDate ? new Date(a.quoteCreatedDate) : null;
      const dateB = b.quoteCreatedDate ? new Date(b.quoteCreatedDate) : null;

      // Sort records with no date (null) to the bottom
      if (dateA === null) return 1;
      if (dateB === null) return -1;

      // Sort by date, newest to oldest
      return dateB - dateA;
    }).map(item => ({
      ...item,
      quoteCreatedDate: item.quoteCreatedDate || '---' // Display '---' for missing dates
    }));
  }, [data]);

  const filteredData = useMemo(() => {
    if (!sortedData || sortedData.length === 0) return [];

    let filtered = sortedData;

    // Search filter
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((directory) =>
        Object.values(directory).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    // Status filter (pending/decline)
    filtered = filtered.filter(
      (item) => item?.status === "pending" || item?.status === "decline"
    );

    return filtered;
  }, [sortedData, searchQuery]);

  useEffect(() => {
    if (data) {
      const searchParams = new URLSearchParams(location.search);
      const quoteId = searchParams.get('quote');
      const quoteNumber = searchParams.get('quoteNumber');

      if (quoteId) {
        const quote = data.find(item => item.id === quoteId);
        if (quote) {
          setSelectId(quoteId);
          setIsModalOpen(true);
        }
      } else if (quoteNumber) {
        const quote = data.find(item => item.quoteNumber === quoteNumber);
        if (quote) {
          setSelectId(quote.id);
          setIsModalOpen(true);
        }
      } else {
        setIsModalOpen(false);
        setSelectId('');
      }
    }
  }, [location.search, data]);

  const { data: admins } = useQuery(
    ["users"],
    async () => {
      const res = await getAdmins();
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  // console.log(data)
  // delete the quotes
  // delete the quotes
  const deleteMutation = useMutation(
    async (id) => {
      if (!id) return;
      try {
        // Close modal immediately
        setShowDeleteConfirmationModal(false);

        const userRef = doc(db, "quotes", id);
        await deleteDoc(userRef);
        return id; // Return ID to use in onSuccess
      } catch (error) {
        console.error("Error deleting quotes", error);
        if (error.code === "not-found") {
          toast.warning("User not found");
        } else {
          toast.error(`Could not delete quotes: ${error.message}`);
        }
        throw error;
      }
    },
    {
      onSuccess: (deletedId) => {
        // 1. Instant Cache Update: Remove item from React Query cache
        queryClient.setQueryData(["quotes", "adminQuery"], (oldData) => {
          return oldData ? oldData.filter((item) => item.id !== deletedId) : [];
        });

        // 2. Instant State Update: Remove item from local state
        setQuotesData((prev) => prev.filter((item) => item.id !== deletedId));

        message.success("Quotes deleted successfully!");
      },
    }
  );

  //edit quotes
  const [editModal, setEditModal] = useState(false);

  const navigate = useNavigate();

  const handleEdit = (id) => {
    // setSelectId(id);
    // console.log(selectId);
    navigate(`/editQuotes/${id}`);
  };
  const [loadingPdf, setLoadingPdf] = useState(false);

  const handleGeneratePdf = async (id) => {
    // console.log(id);
    setLoadingPdf(true);
    try {
      const userDocRef = doc(db, "quotes", id);
      const userDocSnap = await getDoc(userDocRef);
      // console.log(userDocSnap);
      if (userDocSnap.exists()) {
        const formData = userDocSnap.data(); // Set formData inside if block
        const blob = await generatePDF(formData); // Generate PDF using formData
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${formData.quoteNumber}.pdf`;
        link.click();
      } else {
        toast.error("Quote data not found");
      }
      setLoadingPdf(false);
    } catch (error) {
      console.error("Error fetching Quote data:", error);
      toast.error("Error fetching Quote data:", error.message); // Improved error message
      setLoadingPdf(false);
    }
  };

  // const { nextOrderNo } = useNextOrderNumber();
  // console.log(nextOrderNo)
  // Define the updateStatus function

  const updateStatus = async (id) => {
    try {
      setLoading(true);
      // Assigning the order number and updating the quote happen in one idempotent backend transaction.
      const allocRes = await api.post("/firestore/order-number/assign", {
        quoteId: id,
        status: "in progress",
        trackingNumber: generateTrackingNumber(),
        shipmentCreatedDate: new Date().toISOString(),
      });
      const finalOrderNumber = allocRes?.data?.orderNumber;
      if (!finalOrderNumber) {
        throw new Error("Failed to assign order number");
      }

      setLoading(false);
      queryClient.invalidateQueries(["quotes"]);
      toast.success("Quotes Status updated successfully!");
      refetch(); // Refresh data instead of page reload
    } catch (error) {
      setLoading(false);
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };

  const updateSendStatus = async (id) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data();
      setDisabledSendQuotes((prev) => ({ ...prev, [id]: true }));
      if (!quoteData) {
        setDisabledSendQuotes((prev) => ({ ...prev, [id]: false }));
        throw new Error("Quote data not found");
      }

      await updateDoc(userDocRef, {
        sendStatus: true,
      });

      // Send notification to the client
      await api.post("/notifications", {
        title: "New Quote Received",
        message: `You have receive a new quote.`,
        linkText: "View Quote",
        link: `/newquotes`,
        role: "user",
        userId: quoteData.userId, // Assuming the quote has a userId field for the client
        quoteNumber: quoteData.quoteNumber,
        type: "new-quote"
      });

      toast.success("Quote sent to client successfully!");
      setDisabledSendQuotes((prev) => ({ ...prev, [id]: false }));
      queryClient.invalidateQueries(["quotes"]); // Refresh the quotes list
    } catch (error) {
      console.error("Error updating send status:", error);
      setDisabledSendQuotes((prev) => ({ ...prev, [id]: false }));
      toast.error("Error sending quote to client. Please try again later.");
    }
  };

  const handleAssignAdmin = async (id, adminId) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data();

      await updateDoc(userDocRef, {
        assignAdmin: adminId,
      });

      // Find the admin user details from admins data
      const assignedAdmin = admins?.find(admin => admin.name === adminId);
      // console.log(assignedAdmin);

      if (assignedAdmin) {
        // Send notification to the assigned admin
        await api.post("/notifications", {
          userId: assignedAdmin.id,
          role: assignedAdmin.role,
          title: "New Quote Assigned",
          message: `You have been assigned a new quote: ${quoteData.quoteNumber}`,
          linkText: "View Quote",
          link: `/quoteadmin`,
          type: "quote-assigned",
          quoteNumber: quoteData.quoteNumber
        });
      }

      toast.success("Quotes Status updated successfully!");
      queryClient.invalidateQueries(["quotes"]);
      // window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };


  ///update ammount status
  const updateAmount = async () => {
    // console.log("amount");
    // console.log(amount);
    // console.log(currency);
    try {
      const userDocRef = doc(db, "quotes", selectIdForAmount);

      // console.log(userDocRef)
      if (userDocRef && "amount" in userDocRef && "currency" in userDocRef) {
        await updateDoc(userDocRef, {
          amount: amount !== "" ? amount : userDocRef.amount,
          currency: currency !== "" ? currency : userDocRef.currency,
        });
        toast.success("Amount updated successfully!");
      } else {
        // Create amount and currency fields in the document
        await updateDoc(userDocRef, { amount, currency });
        toast.success("Amount and currency added successfully!");
      }

      setIsAmountOpen(false); // Close the modal after updating/creating the fields
      refetch(); // Refetch the data to update the UI
    } catch (error) {
      console.error("Error updating amount:", error.message);
      toast.error("Error updating amount. Please try again later.");
    }
  };

  const handleCommentClick = async (id, quoteNumber) => {
    showModal(id, quoteNumber);
    try {
      await api.put(`/notifications/quotes/${user?.uid}`, {
        role: user.role?.includes("admin") ? "admin" : user?.role,
        quoteNumber: quoteNumber
      });
      queryClient.invalidateQueries(["notifications"]);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  const [selectedStatus, setSelectedStatus] = useState(true);

  const openPopup = () => {
    refetch()
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    refetch();
  };

  const columnsForPageOne = [
    { label: "Company", field: "name" },
    { label: "Quote Number", field: "quoteNumber" },
    { label: "Date", field: "quoteCreatedDate" },
    { label: "Ship To", field: "shipTo" },
    { label: "Status", field: "status" },
    { label: "Assign Task", field: "assignTask" },
    { label: "Send Status", field: "sendStatus" },
    { label: "Quoted Amount", field: "total" }
  ];

  const columns = [
    {
      title: "Company",
      dataIndex: "name",
    },
    {
      title: "Quote Number",
      dataIndex: "quoteNumber",
    },
    {
      title: "Date",
      dataIndex: "quoteCreatedDate",
      render: (quoteCreatedDate) => {
        return quoteCreatedDate === '---' ? '---' : FormatDate(quoteCreatedDate)
      },
    },

    {
      title: "Ship To",
      render: (_, record) =>
        `${getAlpha2Code(record.loadCountry)} - ${getAlpha2Code(
          record.unloadCountry
        )}`,
    },
    // {
    //   title: " Status",
    //   dataIndex: "status",
    //   render: (status) => (
    //     <Tag
    //       className={`border w-1/2 text-center text-white ${status === 'pending' ? "bg-blue-500 " : "bg-red-500 "
    //         } p-2 rounded-md`}
    //     >
    //       {status}
    //     </Tag>
    //   ),
    //   // filters: [
    //   //   { text: "Sent", value: true },
    //   //   { text: "Not Sent", value: false },
    //   // ],
    //   // filteredValue: filteredData ? filteredData.sendStatus : null,
    //   // onFilter: (value, record) => record.sendStatus === value,
    //   // ellipsis: true,
    // },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span className={`${status === 'pending' ? " bg-blue " : "bg-red-500 "}  text-white p-1 px-1 rounded-md border-green border`}>
          {status}
        </span>
      ),
    },
    {
      title: "Assign Task",
      visible: user?.role === "super admin",
      render: (_, record) => (
        <div className="max-w-[150px]">
          <Select
            id="assignAdmin"
            onChange={(value) => handleAssignAdmin(record.id, value)}
            value={record.assignAdmin || "Not Assign "}
            name="assignAdmin"
            placeholder="Select Admin"
            className="w-full"
            options={admins?.map((user) => ({
              label: user.name,
              value: user.name,
              key: user.id,
            }))}
            notFoundContent="Admin not found"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            showSearch
          />
        </div>
      ),
    },
    {
      title: "Send Status",
      dataIndex: "sendStatus",
      render: (sendStatus) => (
        <Tag
          className={`w-full text-center text-white ${sendStatus ? "bg-green-500" : "bg-red-500"
            } px-3 py-2 rounded-md`}
        >
          {sendStatus ? "Sent" : "Not Sent"}
        </Tag>
      ),
      filters: [
        { text: "Sent", value: true },
        { text: "Not Sent", value: false },
      ],
      filteredValue: filteredData ? filteredData.sendStatus : null,
      onFilter: (value, record) => record.sendStatus === value,
      ellipsis: true,
    },

    {
      title: "Actions",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "accept",
                label: (
                  <Space
                    onClick={() => updateStatus(record.id)}
                    className="w-full"
                  >
                    Proceed
                  </Space>
                ),
                onClick: () => updateStatus(record.id),
                visible: true,
              },
              {
                key: "send",
                label: <Space className="w-full">Send Quote</Space>,
                onClick: () => updateSendStatus(record.id),
                disabled: !!disabledSendQuotes[record.id],
                visible: true,
              },
              // {
              //   key: "email",
              //   label: (
              //     <Space
              //       className="w-full"
              //       onClick={async () => {
              //         if (record.email) {
              //           try {
              //             setLoading(true);
              //             const pdfBlob = await generatePDF(record);
              //             console.log(pdfBlob);

              //             const formData = new FormData();
              //             formData.append("pdfFile", pdfBlob, "document.pdf"); // 'pdfFile' is the field name
              //             formData.append("subject", "Quotation"); // Add subject to FormData

              //             // Convert record object to JSON string and append it to FormData
              //             formData.append("record", JSON.stringify(record));

              //             const res = await axios.post(
              //               `${API_BASE_URL}mail`,
              //               formData,
              //               {
              //                 headers: {
              //                   "Content-Type": "multipart/form-data",
              //                 },
              //               }
              //             );
              //             setLoading(false);
              //             toast.success(res.data.message);
              //           } catch (error) {
              //             setLoading(false);
              //             message.error(
              //               error.response?.data?.message ||
              //               "Failed to send email"
              //             );
              //           }
              //         } else {
              //           message.error("Please Add Email");
              //         }
              //       }}
              //     >
              //       Send Email {loading ? <Spin /> : ""}
              //     </Space>
              //   ),
              // },
              {
                key: "comment",
                label: <Space className="w-full">Comment</Space>,
                onClick: () => handleCommentClick(record.id, record.quoteNumber),
                visible: true,
              },
              {
                key: "edit",
                label: <Space className="w-full h-full">Edit</Space>,
                onClick: () => handleEdit(record.id),
                visible: true,
              },

              {
                key: "generatePdf",
                label: (
                  <Space className="w-full">
                    {loadingPdf ? "Generating pdf ...." : "Generate PDF"}
                  </Space>
                ),
                onClick: () => handleGeneratePdf(record.id),
                visible: true,
              },
              {
                key: "delete",
                label: <Space className="w-full">Delete</Space>,
                onClick: () => {
                  setSelectId(record.id);
                  handleMenuClick({ key: "delete" });
                },
                visible: user?.role === "editor" ? false : true,
              },
            ].filter((e) => e.visible),
          }}
          visible={openDropdownIndex === record.id}
          trigger={["click"]}
          onVisibleChange={(visible) => {
            setOpenDropdownIndex(visible ? record.id : null);
          }}
        >
          <a
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenDropdownIndex(record.id);
            }}
          >
            <Space>
              <button className="border relative p-1 rounded-md border-[#053F92]">
                <PiDotsThreeVerticalBold size={20} />
                {notifications?.find(
                  (e) =>
                    e?.quoteNumber === record?.quoteNumber && e?.read === false
                ) ? (
                  <div className="w-2 h-2 absolute -top-[2px] right-0 bg-red-600 rounded-full"></div>
                ) : null}
              </button>
            </Space>
          </a>
        </Dropdown>
      ),
    },
  ];
  // console.log(data)
  return (
    <>
      <Modal
        title={
          <div className="flex flex-col">
            <span>Comments</span>
            <span className="text-xs opacity-60">
              Quote No: {data?.find((q) => q?.id === selectId)?.quoteNumber}
            </span>
          </div>
        }
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"70%"}
        styles={{ body: { padding: 0 } }}
      >
        <AskForModel
          id={selectId}
          quoteNumber={data?.find((q) => q?.id === selectId)?.quoteNumber}
          proposalId={data?.find((q) => q?.id === selectId)?.quoteNumber}
        />
      </Modal>

      <Modal
        title="Sent Amount"
        open={isAmountOpen}
        onOk={handleAmountOk}
        centered
        footer={false}
        onCancel={handleAmountCancel}
      >
        <div className="flex flex-col">
          <label>Sent Amount In:</label>
          <input
            className="border ring-0 outline-none p-1 border-[#878787] rounded-md w-[full] h-[39px]"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <div className="flex gap-2 mt-4">
            <button
              className={
                currency === "USD"
                  ? "border border-[#03336e] w-[60px] h-[40px] rounded-[8px] bg-[#03336e] text-[#fff]"
                  : " border border-[#03336e] w-[60px] h-[40px] rounded-[8px]"
              }
              onClick={() => handleCurrencyChange("USD")}
            >
              Dollar
            </button>
            <button
              className={
                currency === "EUR"
                  ? "border border-[#03336e] w-[60px] h-[40px] rounded-[8px] bg-[#03336e] text-[#fff]   "
                  : "border border-[#03336e]  w-[60px] h-[40px]   rounded-[8px] "
              }
              onClick={() => handleCurrencyChange("EUR")}
            >
              Euro
            </button>
          </div>

          <button
            className="mt-4 w-[130px] text-[#fff] rounded-[8px] h-[40px] bg-[#03336e]"
            onClick={() => updateAmount()}
          >
            Sent Amount
          </button>
        </div>
      </Modal>

      <DashboardLayout>
        {/* <div className="hidden border sm:block border-red">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          {createquote && (
            <>
              <Header title="Create Quote" />
            </>
          )}
          {!createquote && (
            <>
              <Header title="Quote List" />
            </>
          )}
          {!createquote && (
            <>
              <div className="p-2 bg-cus-gray ">
                <div className="flex flex-col items-center justify-between p-3 bg-white rounded-md md:p-5 gap-y-4 md:flex-row">
                  <div className="w-full md:w-auto p-3 flex space-x-2 items-center rounded-[5px] border border-[#355FD8]">
                    <Search />
                    <input
                      placeholder="Search here"
                      className="outline-none w-full"
                      type="text"
                      name=""
                      id=""
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="flex gap-2">
                    <div className="ml-6">
                      <button
                        className="w-full md:w-[192px] h-[50px] btnBg text-white p-2 rounded-md text-sm flex items-center justify-center gap-2"
                        onClick={openPopup}
                      >
                        <Download />
                        <p>Export CSV</p>
                      </button>
                    </div>

                    <div className="flex items-center ">
                      {/* {selectedStatus ?
                        <button className="border-red-500 bg-red-200 w-full md:w-auto flex rounded-[5px] items-center space-x-4 py-2 px-4 text-[#422916]"
                          onClick={() => {
                            setFilteredData(filteredData.filter((item) => item?.sendStatus === false))
                            setSelectedStatus(false)
                          }}
                        >
                          <p>Not Sent Quotes</p>
                        </button>
                        :
                        <button className="border-green-500 bg-green-200 w-full md:w-auto flex rounded-[5px] items-center space-x-4 py-2 px-4 text-[#422916]"
                          onClick={() => {
                            setFilteredData(data.filter(
                              (item) => item?.status === "pending" || item?.status === "decline"
                            ))
                            setSelectedStatus(true)
                          }}
                        >
                          <p>All Quote</p>
                        </button>
                      } */}
                      <button
                        onClick={() => setcreatequote(true)}
                        className="w-full md:w-[192px] h-[50px] btnBg text-white p-2 rounded-md text-sm"
                      >
                        <span className="px-1 bg-white rounded-full text-[#355FD8] me-1">
                          +
                        </span>
                        Create Quote
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between px-3 py-3  bg-white rounded- md:py-5">
                  {/* for web */}
                  <div className="w-full">
                    {isLoading ? (
                      <Loader />
                    ) : isError ? (
                      <div>Error loading quotes: {fetchError || error?.message || "Unknown error"}</div>
                    ) : filteredData.length > 0 ? (
                      <Table
                        columns={columns}
                        dataSource={filteredData}
                        size="small"
                        className="table w-full border-0 mx-auto"
                        locale={{ emptyText: "No data found" }}
                      />
                    ) : (
                      <div>No data found</div>
                    )}
                  </div>
                  {editModal && (
                    <div className="absolute top-20 bg-white w-[85%]">
                      <EditQuotesForm id={selectId} />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          <Modal
            title="Confirm Deletion"
            open={showDeleteConfirmationModal}
            onCancel={() => setShowDeleteConfirmationModal(false)}
            onOk={() => deleteMutation.mutate(selectId)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{
              style: { backgroundColor: "#D83535", color: "#FFFFFF" },
            }}
          >
            <p>Are you sure you want to delete the selected shipment?</p>
          </Modal>

          {/* if create quote true */}
          {createquote && (
            <>
              <AddressFormadmin />
            </>
          )}
        </div>
      </DashboardLayout>
      {/* modal for delete from antd */}
      {showPopup && <ExportCSVPopup closePopup={closePopup} Data={quotesData} columnsToExport={columnsForPageOne} exportName="Quotes" />}
    </>
  );
}

export default Quoteadmin;
